<template>
  <div class="home">
    <div class="main">
      <div>
        <v-header></v-header>
      </div>
      <div class="left">
        <v-menu></v-menu>
      </div>
      <div class="content">
        <transition name="el-zoom-in-top">
          <router-view v-show="show"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import header from './header.vue'
import leftMenu from './leftmenu.vue'
export default {
  data() {
    return {
      curIndex: "1",
      curStaffName: "",
      pageName: "首页",
      operations: [],
      rootPath: "",
      show: true
    }
  },
  components: {
    'v-header': header,
    'v-menu': leftMenu
  },
  created: function() {
    var that = this;
  },
  methods: {
  }
}
</script>

<style lang="scss">
  /*@import '../assets/scss/element-variables';*/

  $commonColor: '#20a0ff';
  .home {
    .content {
      position: absolute;
      left: 200px;
      top: 70px;
      bottom: 0;
      overflow: scroll;
      width: calc(100% - 210px);
    }
    .content::-webkit-scrollbar {
      display: none;
    }
  }

</style>
